import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { CatalogPostingsSwipperComponent } from './components/catalog-postings-swiper/catalog-postings-swiper.component';
import { CatalogSidebarComponent } from './components/catalog-sidebar/catalog-sidebar.component';
import { CourseCatalogPostingCardComponent } from './components/course-catalog-posting-card/course-catalog-posting-card.component';
import { CourseCatalogSearchComponent } from './components/course-catalog-search/course-catalog-search.component';
import { CourseCatalogComponent } from './components/course-catalog/course-catalog.component';
import { SelectCourseOfferingPostingCardComponent } from './components/select-course-offering-posting/select-course-offering-posting.component';
import { MatStepperModule } from '@angular/material/stepper';
import { CatalogOfferingsDialogComponent } from './dialogs/catalog-offerings-dialog/catalog-offerings-dialog.component';
import { CatalogPostingsDialogComponent } from './dialogs/catalog-postings-dialog/catalog-postings-dialog.component';
import { CourseCatalogPreviewDialogComponent } from './dialogs/catalog-preview/course-catalog-preview.component';
import { CourseCatalogOverviewResolver } from './services/course-catalog-overview.resolver';
import { CourseCatalogApiService } from './services/course-catalog.api-service';
import { CourseCatalogService } from './services/course-catalog.service';

@NgModule({
    imports: [
        MaxBrainSharedModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatChipsModule,
        MatIconModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        MatMenuModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatStepperModule,
    ],
    declarations: [
        CourseCatalogPreviewDialogComponent,
        CatalogSidebarComponent,
        CatalogPostingsSwipperComponent,
        CourseCatalogComponent,
        CourseCatalogPostingCardComponent,
        CourseCatalogSearchComponent,
        CatalogPostingsDialogComponent,
        SelectCourseOfferingPostingCardComponent,
        CatalogOfferingsDialogComponent,
    ],
    exports: [
        CourseCatalogPreviewDialogComponent,
        CatalogSidebarComponent,
        CatalogPostingsSwipperComponent,
        CourseCatalogComponent,
        CourseCatalogPostingCardComponent,
        CourseCatalogSearchComponent,
        CatalogPostingsDialogComponent,
        SelectCourseOfferingPostingCardComponent,
        CatalogOfferingsDialogComponent,
    ],
    providers: [CourseCatalogApiService, CourseCatalogService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CourseCatalogModule {
    static forRoot(): ModuleWithProviders<CourseCatalogModule> {
        return {
            ngModule: CourseCatalogModule,
            providers: [CourseCatalogApiService, CourseCatalogService, CourseCatalogOverviewResolver],
        };
    }
}
